/**
 * @Desription: 登录-登录初始化调用方法
 * @Author: netstar.sjj
 * @Date: 2021-10-25 16:05:00
 * @class NSLogin
*/
import loginSubmit from './login-submit';//提交
declare const window:any;
namespace loginManager{
    let config:any = {};
    export const submit = loginSubmit;
    const loginInfo:any = {
        //保存登录页config到本地存储，以方便之后调用
        save:function(){
            let storeConfigStr = JSON.stringify(config);
            window.store.set('NetstarLoginConfig', storeConfigStr);
        },
        //清除登录页config的本地存储
        clear:function(){
            window.store.remove('NetstarLoginConfig');
        }
    }
    const initImages:Function = function(){
        let bgImage:string = config.images.bg;
        let logoImage:string = config.images.logo;
        window.jQuery(config.containerEl).attr('style', "background-image:url("+bgImage+")");
        window.jQuery(config.containerEl + ' .logo img').attr('src', logoImage);
    }
    //是否显示手机登录、微信登录、企业微信登录 gst20200518
    //若有需要则在页面的NSLogin.init()中添加hideMobile(是否显示手机登录)和hidewxChat(是否隐藏微信、企业微信登录)参数，true为显示，若不写则默认为true
    const isShow:Function = function(){
        if(config.hideMobile === true){
            window.jQuery('#mobile').addClass("hide");//是否隐藏手机登录 由于无法找到准确的标签，所以在页面html中添加了一个id
        }
        if(config.hidewxChat === true){
            window.jQuery('.login-choose').addClass("hide");//是否隐藏微信登录、企业微信登录
        }
    }
    const initWxChatUrl:Function = function(){
        if(config.wxChatEl){
            window.jQuery(config.wxChatEl).attr('href','javascript:NSLogin.loginManger.toWxChatUrl();');
        }
        if(config.wxChatEl){
            window.jQuery(config.qyWxChatEl).attr('href','javascript:NSLogin.loginManger.toQyWxChat();');
        }
    }
    //如果页面是来自于微信登录跳转 url会添加 code 和 state 参数
    ///workweixin/workWeixinUserEmps/login?authCode=xxx&state=xxx 返回token
    const loginByScan:Function = function(){
        let loginUrlParams:any = window.NSUtils.getUrlPara();
        //微信获取token登录
        if(loginUrlParams.code && loginUrlParams.state&&!loginUrlParams.loginType){             
            window.jQuery.ajax({
                url:window.NSUtils.getAPIUrl() + 'workweixin/weChatLogin/login',
                data:{
                    code:loginUrlParams.code,
                    state:loginUrlParams.state
                },
                type:'GET',
                success:function(res:any){
                    if(res.success == false){
                        window.nsalert(window.language.login.scancode.error, 'error');
                        console.error(window.language.login.scancode.error,'error');
                        return;
                    }
                    window.NSLogin.serverData = res;
                    window.NSLogin.loginRes = res;
                    window.NSLogin.Authorization = res.data.token;
                    window.NSUtils.OAuthCode.set({
                        authorization:      window.NSLogin.Authorization, 
                        expireMinute:       config.expireMinute,
                        loginTimeStamp:     new Date().getTime(),
                    });
                    window.NSLogin.toHomePage(window.NSLogin.Authorization);
                },
                error:function(error:any){
                    window.nsalert(window.language.login.scancode.error, 'error');
                    console.error(window.language.login.scancode.error,'error');
                }
            })
        }
        //yl 22/09/28 企业微信扫码登录 直接走免密登录认auth_code 故先注释一下代码 后续可根据情况选用
        //企业微信获取token登录 
        // if(loginUrlParams.auth_code && loginUrlParams.state){
        //     window.jQuery.ajax({
        //         url:window.NSUtils.getAPIUrl() + 'workweixin/workWeixinUserEmps/login',
        //         data:{
        //             authCode:loginUrlParams.auth_code,
        //             state:loginUrlParams.state
        //         },
        //         type:'GET',
        //         success:function(res:any){
        //             if(res.success == false){
        //                 window.nsalert(window.language.login.scancode.error, 'error');
        //                 console.error(window.language.login.scancode.error,'error');
        //                 return;
        //             }
        //             window.NSLogin.serverData = res;
        //             window.NSLogin.loginRes = res;
        //             window.NSLogin.Authorization = window.NSLogin.res.data.token;
                    
        //             window.NSUtils.OAuthCode.set({
        //                 authorization:      res.data.token, 
        //                 expireMinute:       config.expireMinute,
        //                 loginTimeStamp:     new Date().getTime(),
        //             });
        //             window.NSLogin.toHomePage(window.NSLogin.Authorization);
        //         },
        //         error:function(error:any){
        //             window.nsalert(window.language.login.scancode.error, 'error');
        //             console.error(window.language.login.scancode.error,'error');
        //         }
        //     })
        // }
    }
    //点击LOGO加入收藏夹功能
    const addFav:Function = function() {
        let href:string = window.location.href; //地址
        let orgname:string = window.jQuery(config.orgnameEl).val(); //组织名称
        let username:string = window.jQuery(config.usernameEl).val(); //帐号
        let enCodeorgname:string = encodeURIComponent(orgname); //组织名称转码
        let enCodeusername:string = encodeURIComponent(username); //帐号名称转码
        if(href.indexOf('?')==-1){
            let enUrl:string = href + '?orgname=' + enCodeorgname + '&username=' + enCodeusername; //拼成可以存储信息的地址（不包含密码）
            window.open(enUrl);
        }else{
            let endhref:number = href.indexOf('?');
            let newhref:string = href.slice(0,endhref);
            let enUrl:string = newhref + '?orgname=' + enCodeorgname + '&username=' + enCodeusername; //拼成可以存储信息的地址（不包含密码）
            window.open(enUrl);
        }
    }
    const enterEvent:Function = function(event:any){
        let browser =  window.navigator.appName;
        let userAgent = window.navigator.userAgent;
        let code:number;
        if(browser.indexOf('Internet')>-1){//IE
            code = window.event.keyCode;
        }else if(userAgent.indexOf('Firefox')>-1){//Firefox
            code = event.which;
        }else{//其他浏览器
            code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
        }
        if (code == 13) {
            window.NSLogin.loginManger.submit();
        }
    }
    export function refreshVerImg(){
        let config:any = window.NSLogin.config;
        let userNameVal:string = window.jQuery(config.usernameEl).val();
        let orgNameVal:string = window.jQuery(config.orgnameEl).val();
        let orgName:string = encodeURIComponent(orgNameVal);
        let userName:string = encodeURIComponent(userNameVal);
        let random:number = Math.random() * 100;
        let verificationImgUrl:string = window.NSUtils.getAPIUrl() + '/verificationCode?'+ "orgName=" + orgName +"&"+ "username=" +userName+ "&random=" + random;
        let htmlImg:string ='<img class="verification-img-size" src="'+ verificationImgUrl+'"><br/><a href="javascript:void(0);" id="refreshVerificationImg">'+window.language.login.verifiyName+'</a>';
        window.jQuery(config.verificationImgEl).html(htmlImg);
        window.jQuery('#refreshVerificationImg').off('click').on('click',window.NSLogin.loginManger.refreshVerImg);
    }
    export const remember:any = {
        set:function(){
            let config:any = window.NSLogin.config;
            let isRemember:boolean = window.jQuery('#remember').prop("checked");
            if(isRemember === true){
                let orgName:string = window.jQuery(config.orgnameEl).val();
                let userName:string = window.jQuery(config.usernameEl).val();
                let loginRemember:any = {
                    orgName:orgName,
                    userName:userName,
                    remember:true,
                };
                window.store.set('NetstarLoginRemember', loginRemember);
            }else{
                //如果不保存，也需要记录点了不保存
                window.store.set('NetstarLoginRemember',{remember:false});
            }
        },
        //显示到页面输入框里
        get:function(){
            let config:any = window.NSLogin.config;
            let loginRemember:any = window.store.get('NetstarLoginRemember');
            if(typeof(loginRemember)!= 'object'){
                loginRemember = {};
            }
            let urlParams:any = window.NSUtils.getUrlPara();
            let orgValues:any = config.orgValues;
            //优先使用url传进来的参数
            let urlOrgName:string = '';
            if(urlParams.orgname && orgValues){
                if(orgValues[urlParams.orgname]){
                    urlOrgName = orgValues[urlParams.orgname];
                }
            }
            //如果选择了记录则读取
            if(loginRemember.remember){
                //读取url中的组织名称 用户名 密码 优先使用url传进来的参数 cy 191113
                if(urlOrgName!=''){
                    //如果url传进来的orgName跟本地存储的不一样则清空userName
                    if(loginRemember.orgName != urlOrgName){
                        loginRemember.userName = '';
                    }
                    loginRemember.orgName = urlOrgName;
                }
                if(urlParams.username){
                    loginRemember.userName = urlParams.username;
                }
                if(urlParams.password){
                    loginRemember.password = urlParams.password;
                }
                window.jQuery(config.orgnameEl).val(loginRemember.orgName);
                window.jQuery(config.usernameEl).val(loginRemember.userName);
                if(loginRemember.password){
                    window.jQuery(config.passwordEl).val(loginRemember.password);
                }
            }else{
                window.jQuery('#remember').prop("checked", false);
                if(urlOrgName != ''){
                    window.jQuery(config.orgnameEl).val(urlOrgName);
                }
                if(urlParams.username){
                    window.jQuery(config.usernameEl).val(urlParams.username);
                }
                if(urlParams.password){
                    window.jQuery(config.passwordEl).val(urlParams.password);
                }
            }
        }
    }
    export function getScanCodeUrl() {
        let regUrls:any =  {
            'https://qa.wangxingcloud.com/':'https://qa.wangxingcloud.com/',
            'https://wangxingcloud.com/':'https://wangxingcloud.com/',
        };
        let logonUrl = window.location.protocol + '//' + window.location.host;
        if(regUrls[logonUrl] ){
            return logonUrl;
        }else{
            return 'https://qa.wangxingcloud.com/'; 
        }
    }
    //微信
    export function toWxChatUrl(){
        let config:any = window.NSLogin.config;
        if(typeof(config.wxChatAjax)!='object'){
            return;
        }
        window.jQuery.ajax({
            url:config.wxChatAjax.url,
            type: "GET",
            data:{
                domain:window.NSLogin.getScanCodeUrl(),
            },
            dataType: 'text',
            success:function(res:any){
                let wxChaturl:string = res;
                window.open(wxChaturl,"_blank"); 
            },
            error: function(){
                window.nsalert(window.language.login.wx.error,'error');
                console.log(window.language.login.wx.error);
            },
        })
    }
    //企业微信
    export function toQyWxChat() {
        let config:any = window.NSLogin.config;
        if(typeof(config.qyWxChatAjax)!='object'){
            return;
        }
        window.jQuery.ajax({
            url:config.qyWxChatAjax.url,
            type: "GET",
            headers:{
                "content-type":" application/x-www-form-urlencoded"
            },
            dataType: 'json',
            success:function(res:any){
                if(res.success&& res.data&&res.data.url){
                    let url:string = res.data.url.replace("redirect_uri=","redirect_uri="+window.NetstarApiConfig.webRootPath);
                    window.open(url ,"_blank"); 
                }else{
                    window.nsalert("未能成功生成连接")
                }

            },
            error: function(err){
                window.nsalert(window.language.login.wx.error,'error');
                console.log(window.language.login.wx.error);
            },
        })
    }
    export function clear(){
        /**
         * 清除登录页面 清除页面上的style  body中的html等
         * 包括  config.styleEl config.containerEl
        */
        let config:any = window.NSLogin.config;
        let $loginContainer:any = window.jQuery(config.containerEl);
        let $loginStyle:any = window.jQuery(config.styleEl);
        $loginContainer.remove();
        $loginStyle.remove();
    }
    export function init() {
        config = window.NSLogin.config;
        //loginInfo.save();
        initImages();
        isShow();
        window.jQuery('.logo img').css('cursor','pointer');
        window.jQuery('.logo img').on('click', function(){
            addFav();
        })
        window.jQuery(document).on('keyup',enterEvent);
        remember.get();
        window.jQuery(config.submitBtnEl).on('click', function(ev:any){
            config.$login.addClass('login-loading');
            window.NSLogin.loginManger.submit();
        });
        initWxChatUrl();
        loginByScan();
    }
}
export default loginManager;